module.exports = __webpack_public_path__ + "static/logo-500x500-051da0bae57093b5ccdd6e68e181c646.png";